import { render, staticRenderFns } from "./reply-btn.vue?vue&type=template&id=1c35c3ce&"
import script from "./reply-btn.vue?vue&type=script&lang=js&"
export * from "./reply-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports